import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

// AddToMyInterest Button Container for Tablet and Mobile
export const StActionButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.up('lg')]: {
    '.MuiButton-root': {
      display: 'none',
    },
  },
  [theme.breakpoints.down('lg')]: {
    justifyContent: 'flex-end',
    padding: '2rem 1.5rem',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '1rem',
    justifyContent: 'center',
    '.MuiButton-root': {
      padding: '5px',
    },
  },
}));

export const StInfoContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
}));

export const StInfoWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  maxWidth: '1366px',
  width: '100%',
  padding: '1rem 4rem',
  [theme.breakpoints.up(1200)]: {
    padding: '1rem 6rem',
  },
  [theme.breakpoints.down('lg')]: {
    padding: '0.8rem 0px',
    justifyContent: 'center',
    '#action-button-set': {
      display: 'none',
    },
    '.MuiTypography-root': {
      textAlign: 'center',
    },
  },
  [theme.breakpoints.down('sm')]: {
    padding: '0.8rem 2rem',
  },
}));
